import { render, staticRenderFns } from "./noAutorizado.vue?vue&type=template&id=4bc5d010&"
import script from "./noAutorizado.vue?vue&type=script&lang=js&"
export * from "./noAutorizado.vue?vue&type=script&lang=js&"
import style0 from "./noAutorizado.vue?vue&type=style&index=0&id=4bc5d010&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports